module.exports = __webpack_public_path__ + "img/pr-4.4fc75bbe.png";